import { createAction } from '@reduxjs/toolkit';
import { withPayloadType } from 'utils';

export const showJobStart = createAction(
  'SHOW_JOB::START',
  withPayloadType<{ id: string; organizationId: string }>(),
);
